<script lang="ts">
    import type { InstachatTexts, Role } from "./instachat";
    import type { JitsiSettings } from "./jitsi";
    import ParticipantChat from "./ParticipantChat.svelte";
    import SupervisorChat from "./SupervisorChat.svelte";

    export let texts: InstachatTexts;
    export let role: Role;
    export let jitsi: JitsiSettings;
</script>

{#if role === "participant"}
    <ParticipantChat {jitsi} {texts} />
{:else}
    <SupervisorChat {jitsi} />
{/if}
